import { render, staticRenderFns } from "./BlogBanner.vue?vue&type=template&id=2793a9bf&"
import script from "./BlogBanner.vue?vue&type=script&lang=js&"
export * from "./BlogBanner.vue?vue&type=script&lang=js&"
import style0 from "./BlogBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports